import { captureException, log, sgVersion } from '../common/helpers'
import { SGPlugin } from "../common/SGPlugins";

declare global {
  interface HTMLElement {
    svelteSSRAttached?: boolean
  }
}

// noinspection JSUnusedGlobalSymbols
export default (elements: NodeListOf<HTMLElement>) => {
  elements.forEach(element => {
    if (element.svelteSSRAttached) {
      return
    }
    element.svelteSSRAttached = true
    const options = SGPlugin.getElementOptions(element, 'sveltessr')
    if (!options.id) {
      return
    }
    const propsScript = document.head.querySelector(`script[data-sveltesrr-data="${options.id}"]`)

    if (!propsScript) {
      log('SvelteSSR', element)
      captureException('SvelteSSR', new Error(`Для SSR-виджета Svelte ${options.id} нет информации`))
      return;
    }

    const params = JSON.parse(propsScript.innerHTML)
    for (let key in params.props) {
      if (typeof params.props[key] !== 'string' || !params.props[key].startsWith('func:')) {
        continue
      }
      let functionText = params.props[key].replace(/^func:/, '')
      functionText = JSON.parse(functionText)
      params.props[key] = new Function(...functionText)
    }
    if (!params.keepProps) {
      propsScript.remove()
    }
    import(`/dist/js/components/${params.component}.js?${sgVersion()}`).then(({default: Component}) => {
      element.innerHTML = ''
      new Component({
        target: element,
        props: params.props
      })
    })
  })
}
